import { useEffect, useMemo, useState } from "react";
import "./floating-nav.css";

const SECTION_LINKS = [
  { id: "home", label: "Início" },
  { id: "about", label: "Sobre" },
  // { id: "process", label: "Processo" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projetos" },
  { id: "contact", label: "Contato" },
];

const SCROLL_THRESHOLD = 240;

function scrollToSection(id) {
  if (typeof window === "undefined") return;

  if (id === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }

  const target = document.getElementById(id);
  if (!target) return;

  const header = document.querySelector(".s-header");
  const headerHeight = header?.offsetHeight || 0;
  const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 12;

  window.scrollTo({ top, behavior: "smooth" });
}

export default function FloatingNav() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  const links = useMemo(() => SECTION_LINKS, []);

  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > SCROLL_THRESHOLD;
      setVisible(show);
      if (!show) setOpen(false);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!open) return;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  const handleNavigate = (id) => {
    scrollToSection(id);
    setOpen(false);
  };

  return (
    <div className={`floating-nav ${visible ? "is-visible" : ""} ${open ? "is-open" : ""}`}>
      <button
        type="button"
        className="floating-nav__toggle"
        aria-expanded={open}
        aria-label={open ? "Fechar navegação rápida" : "Abrir navegação rápida"}
        onClick={() => setOpen((prev) => !prev)}
      >
        <svg
          className="floating-nav__icon"
          width="28"
          height="28"
          viewBox="0 0 48 48"
          aria-hidden="true"
        >
          <path
            d="M24 4c-5.3 0-11.4 12.5-12.9 16.2-.4.9-.1 2 .7 2.5l4.4 2.9c.7.5 1.6.4 2.2-.2l2-2c.6-.6 1.5-.6 2.1 0l2 2c.6.6 1.5.7 2.2.2l4.4-2.9c.8-.5 1.1-1.6.7-2.5C35.4 16.5 29.3 4 24 4Z"
            fill="url(#ship-gradient)"
          />
          <path
            d="M24 4c-5.3 0-11.4 12.5-12.9 16.2-.4.9-.1 2 .7 2.5l4.4 2.9c.7.5 1.6.4 2.2-.2l2-2c.6-.6 1.5-.6 2.1 0l2 2c.6.6 1.5.7 2.2.2l4.4-2.9c.8-.5 1.1-1.6.7-2.5C35.4 16.5 29.3 4 24 4Z"
            fill="none"
            stroke="rgba(255,255,255,0.8)"
            strokeWidth="1.2"
          />
          <path
            d="M17 27c-1.8 3.8-4 10.1-2.7 11.4 1.3 1.3 7.6-.9 11.4-2.7"
            stroke="rgba(102,230,255,0.6)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="24" cy="19" r="3.2" fill="rgba(255,255,255,0.85)" />
          <defs>
            <linearGradient id="ship-gradient" x1="14" x2="34" y1="8" y2="28" gradientUnits="userSpaceOnUse">
              <stop stopColor="#66e6ff" />
              <stop offset="0.55" stopColor="#b084ff" />
              <stop offset="1" stopColor="#ffb6ff" />
            </linearGradient>
          </defs>
        </svg>
        <span className="floating-nav__toggle-glow" aria-hidden="true" />
      </button>

      <div className="floating-nav__menu" role="menu">
        {links.map((link) => (
          <button
            key={link.id}
            type="button"
            className="floating-nav__link"
            onClick={() => handleNavigate(link.id)}
            role="menuitem"
          >
            {link.label}
          </button>
        ))}
        <div className="floating-nav__divider" aria-hidden="true" />
        <button
          type="button"
          className="floating-nav__link floating-nav__link--top"
          onClick={() => handleNavigate("top")}
        >
          Voltar ao topo
        </button>
      </div>
    </div>
  );
}
